// React
import { React, createContext, useContext, useEffect, useState } from "react";

// Firebase
import { auth } from "../configuration/firebase";
import { signInWithEmailAndPassword, signOut, onAuthStateChanged, sendPasswordResetEmail } from "firebase/auth";

// @mui
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";

// A ---------------------------------------------------------------------- M

const UserContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const signIn = (email, password) => {
    return signInWithEmailAndPassword(auth, email, password);
  };

  const handleLogout = () => {
    return signOut(auth);
  };

  const resetPassword = async (email) => {
    try {
      await sendPasswordResetEmail(auth, email);
    } catch (error) {
      console.error("Error in resetPassword:", error.message);
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setIsLoading(false);
      setUser(currentUser);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  if (isLoading)
    return (
      <Grid item container justifyContent="center" mt="30%">
        <Grid item>
          <CircularProgress />
        </Grid>
      </Grid>
    );

  return (
    <UserContext.Provider
      value={{
        user,
        signIn,
        handleLogout,
        resetPassword,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const UserAuth = () => {
  return useContext(UserContext);
};
